import React from "react"
import Chevron from "./svgs/chevron"
import styled from "styled-components"
import NavbarMenuSlider from "./navbar-menu-slider"
import NavbarMenuSliderItem from "./navbar-menu-slider-item"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const Text = styled.div`
  color: #272d37;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const Holder = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  cursor: pointer;
`

const CtaButtonHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid #eceff3;
`

const BrowseButton = styled(Link)`
  text-decoration: none;
  display: block;
  margin: 0px 16px;
  margin-bottom: 0;
  padding: 12px 16px;
  width: auto;
  border: none;
  background-color: #daece4;
  border-radius: 8px;
  cursor: pointer;
  color: #2b4346;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  &:hover {
    background-color: #c7e4d0;
  }
`

const NavbarMenuSliderItemMain = ({
  name,
  index,
  items,
  isOpen,
  setIsOpen,
  spread,
}) => {
  return (
    <>
      <Holder onClick={() => setIsOpen(index)}>
        <Text>{name}</Text>
        <Chevron />
      </Holder>
      <NavbarMenuSlider
        isOpen={isOpen === index}
        setIsOpen={setIsOpen}
        backToindex={0}
        name={name}
      >
        {items.map(item => (
          <NavbarMenuSliderItem
            key={item.name}
            url={item.url || item.uri}
            items={item.items}
            name={item.name}
          />
        ))}
        <CtaButtonHolder>
          {spread?.header?.items.map(item => {
            return (
              <BrowseButton key={item.id} to={item.url}>
                {item.name}
              </BrowseButton>
            )
          })}
        </CtaButtonHolder>
      </NavbarMenuSlider>
    </>
  )
}

NavbarMenuSliderItemMain.propTypes = {
  spread: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setIsOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
  index: PropTypes.number,
  name: PropTypes.string,
}

export default NavbarMenuSliderItemMain
